import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbOffcanvas, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FileService } from '../../../../../core/services/file.service';
import { InqueryService } from '../../../../../core/services/inquery.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-inquery-index',
    templateUrl: './inquery-index.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule, AngularEditorModule, NgxPaginationModule],
    styleUrls: ['./inquery-index.component.css']
})
export class InqueryIndexComponent {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  @ViewChild('contentFiche') contentFiche:TemplateRef<any> | undefined
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfViewLoader=false
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   roles:any[] =[]
   data:any[] =[]
   selected_data:any;
   modalOption:any; 
   type:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-inqueries"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
   fileInput:any
 
 
   constructor(
    private spinnerService:NgxSpinnerService,
     private inqueryService:InqueryService,
     private toastrService:ToastrService,
     private fileService:FileService,
     private router:Router,
     private activatedRoute:ActivatedRoute,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
       private offcanvasService: NgbOffcanvas,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     this.init()
 this.getActions()
 this.user=this.lsService.get(GlobalName.userName)
 this.role=this.user.roles[0].name.toLowerCase()
   }
 
   init(){
    this.activatedRoute.paramMap.subscribe((res)=>{
      this.data=[]
         this.type=this.activatedRoute.snapshot.paramMap.get('type') ?? '';
   
   if(this.type!= undefined){
    this.getRequeteByState()
   }else{
    this.router.navigate(['/admin/dashboard'])

   }
    })
   
   }
 
   getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get2({path:`${code}/${filename}`}).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });
    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des préoccupations",err)

    })
  }
 
   getRequeteByState(){
     this.inqueryService.getRequeteByState(this.type).subscribe((res:any)=>{
       this.data=res.data
       this.pg.pageSize=10
       this.pg.p=0
       this.pg.total=res.data.length
       this.modalService.dismissAll()
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des préoccupations",err)

     })
   }
 
 
   store(value:any){
    let formData= new FormData()
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
        formData.append("filename",this.fileInput)
    }

     this.loading=true
     
     this.inqueryService.store(formData).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getRequeteByState()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des préoccupations",err)

     })
   }
   update(value:any){

     let formData= new FormData()
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
        formData.append("filename",this.fileInput)
    }

     this.loading=true
 
     this.inqueryService.update(this.selected_data.id,formData).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getRequeteByState()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des préoccupations",err)

     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.inqueryService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getRequeteByState()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des préoccupations",err)

     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.router.navigate(['/admin/inquery-details/'+this.selected_data.code])
    //  this.modalOption={centered:false,size:"lg"}
    //  this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.inqueryService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getRequeteByState()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des préoccupations",err)

       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
   upload(ev:any){
    if (ev?.target.files.length!=0) {
      this.fileInput=ev?.target.files[0]
    }
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:true,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
